<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#" (click)="clicked($event)"><i class="fa fa-bars"></i></a>